export const MAIN = '/';
export const ABOUT = '/about';
export const EMPLOYERS = '/employers';
export const JOBSEEKERS = '/jobseekers';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_OF_USE = '/terms-of-use';
